import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './EcardAllFiles.module.scss';
import useDocumentationFiles from '../../Hooks/useDocumentationFiles';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
import ECardAllFilesItem from './ECardAllFilesItem';
import { ECardView } from '../../Enums/ECardView.enum';
import { FileToShare } from '../ECard/ECard';
import { useAppContext } from '../../../../Services/AppContext';
import { ECardType } from '../../Enums/ECardType.enum';

interface EcardAllFilesProps {
	patientId: string;
	view: ECardView;
	filter?: string;
	isLoading?: boolean;
	isShareMode: boolean;
	onItemCheck: (file: FileToShare, isChecked: boolean) => void;
	filesToShare: FileToShare[];
	eCardType: ECardType;
}

const wrapperId = 'eCardAllFilesWrapper';

const ECardAllFiles: React.FC<EcardAllFilesProps> = ({
	patientId,
	view,
	filter,
	isLoading: propsIsLoading,
	isShareMode,
	onItemCheck,
	filesToShare,
	eCardType,
}) => {
	const { getDocumentationFiles, getNextPage, data, isLoading, page } =
		useDocumentationFiles();
	const { socket } = useAppContext();
	const [flatData, setFlatData] = useState<any[]>([]);
	const [hasMoreData, setHasMoreData] = useState(false);

	useEffect(() => {
		loadDocumentationFiles();
	}, [page, filter, propsIsLoading]);

	useEffect(() => {
		if (data) {
			const documentationFilesData = data?.documentationFiles?.data;
			const totalPages = data?.documentationFiles?.meta?.totalPages;
			const page = data?.documentationFiles?.meta?.page;

			if (documentationFilesData) {
				if (page && page > 1) {
					setFlatData(prevFlatData => [
						...prevFlatData,
						...documentationFilesData,
					]);
				} else {
					setFlatData(documentationFilesData);
				}
			}

			if (totalPages && page) {
				setHasMoreData(totalPages > page);
			}
		}
	}, [data]);

	const updateFile = (fileId: string, newData: any) => {
		const tempData = flatData ? [...flatData] : undefined;
		if (tempData) {
			for (const tempItemKey in tempData) {
				const tempItem = tempData[tempItemKey];
				if (tempItem.id === fileId) {
					tempData[tempItemKey] = { ...tempItem, ...newData };
				}
			}
			setFlatData(tempData);
		}
	};

	socket.on('message', data => {
		if (typeof data.generatedNewThumb !== 'undefined') {
			flatData?.map(file => {
				if (file.id === data.generatedNewThumb) {
					updateFile(file.id, data.updatedData);
				}
			});
		} else if (typeof data.avResult !== 'undefined') {
			flatData?.map(file => {
				if (file.id === data.avResult) {
					updateFile(file.id, data.updatedData);
				}
			});
		}
	});

	const loadDocumentationFiles = () => {
		getDocumentationFiles(patientId, filter);
	};

	return (
		<ScrollContainer wrapperId={wrapperId} className={styles.wrapper}>
			<FlatList
				onRefresh={loadDocumentationFiles}
				onLoadMore={getNextPage}
				data={flatData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={wrapperId}
				className={view === ECardView.GRID ? 'row' : ''}
				renderItem={item => (
					<ECardAllFilesItem
						item={item}
						view={view}
						reloadData={loadDocumentationFiles}
						isShareMode={isShareMode}
						onItemCheck={onItemCheck}
						filesToShare={filesToShare}
						canBeEdited={eCardType === ECardType.HEALTH_DOCUMENTATION}
						eCardType={eCardType}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default ECardAllFiles;
